module.exports = __webpack_public_path__ + "img/214.6aff5eff.jpg";